// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"624":"clere","738":"course-manager"}[chunkId] || chunkId) + "." + {"354":"024f89c5","368":"5c83349e","624":"0c9aed50","668":"e30198d9","738":"3bbe8cb1","801":"61b1064a","838":"3787910e"}[chunkId] + ".js";
};